<div class="flex flex-row justify-between pb-10">
    <div class="flex flex-col mb-10">
      <div class="mat-headline fw-700 fs-22 mt-20  ml-20">{{'INSTANCE_DETAILS.UPDATE_MENU.UPDATE_RELEASE_PACKAGE' | transloco}}
      </div>
    </div>
  </div>
  <mat-divider class="mb-10 neutral-2 ml-20 mr-20"></mat-divider>
  <div class="mat-subheading-2 fw-500 fs-16 ml-20 mt-20">
    {{'INSTANCE_DETAILS.UPDATE_MENU.SKIP_TEST_UPDATE' | transloco}}.
  </div>
  <div class="mat-subheading-2 fw-500 fs-16 ml-20 mt-20">
    {{'INSTANCE_DETAILS.UPDATE_MENU.EXCECUTE_TEST' | transloco}} 
  </div>
  <div class="flex items-center tbl-cell col-select user-select-none">
    <div class="flex flex-row mt-10">
      <mat-icon [svgIcon]="skipTest? 'radio_button_checked': 'radio_button_unchecked'" (click)="executeTest(true)" class="radio-icon cursor-pointer mb-14 ml-20 mt-10"></mat-icon>
      <div class="mat-subheading-2 fw-700 fs-16 ml-1 mt-10">{{'INSTANCE_DETAILS.UPDATE_MENU.SKIPTEST_YES' | transloco}}</div>
    </div>
  
    <div class="flex flex-row mt-10 ">
        <mat-icon [svgIcon]="!skipTest? 'radio_button_checked': 'radio_button_unchecked'" (click)="executeTest(false)" class="radio-icon cursor-pointer mb-14 ml-20 mt-10"></mat-icon>
        <div class="mat-subheading-2 fw-700 fs-16 ml-1 mt-10">{{'INSTANCE_DETAILS.UPDATE_MENU.SKIPTEST_NO' | transloco}}</div>
    </div>
  
  </div>
  <div class="flex flex-row justify-end items-center mt-50">
    <button class="white mr-20 mb-20" type="button" (click)="cancel();"> {{ 'BUTTONS.CANCEL' | transloco }} </button>
    <button class="error-report-bg-color accent mr-20 mb-20" type="button" (click)="submit()"> {{ 'BUTTONS.SUBMIT' | transloco }}</button>
  </div>